import angular from 'angular';

export const selector = 'dbAOutsideClick';

/* @ngInject */
export default function OutsideClickDirective($document, $parse) {
    return {
        restrict: 'A',

        link(scope, element, attrs) {
            let click = $parse(attrs[selector]);

            $document.on('click', clickHandler);
            element.on('$destroy', () => $document.off('click', clickHandler));

            function clickHandler(event) {
                if (element[0] !== event.target && !isChild(angular.element(event.target))) {
                    scope.$applyAsync(click(scope));
                }
            }

            function isChild($element) {
                if (!$element || $element.length === 0) {
                    return false;
                }

                return $element[0] === element[0]
                    ? true
                    : isChild($element.parent());
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/directive/outside-click/outside-click.directive.js